import { makeStyles } from '@material-ui/core';
import qs from 'qs';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import lifecycle from 'react-pure-lifecycle';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import axiosInstance from '../config';
import { logout } from './Utils';

// Lifecycle methods
const methods = {};

const useStyles = makeStyles((theme) => ({
  red: {
    color: '#DC252F',
  },
  spacer: {
    background: '#DEDEDE',
    border: 'none !important',
    padding: '0px !important',
  },
  spacerth: {
    padding: '0px !important',
    fontStyle: 'italic',
    minWidth: '12px',
    fontSize: '9px !important',
  },
  textCenter: {
    textAlign: 'center !important',
  },
  singleCell: {
    padding: '4px 4px 4px 4px',
    height: '36px',
  },
  singleExtremes: {
    width: '99%',
    margin: '0 auto',
    color: '#1452CC',
    fontWeight: 'bold',
    textAlign: 'center',
    minWidth: '32px',
  },
  topEvent: {
    paddingBottom: '2px !important',
  },
  bottomEvent: {
    paddingTop: '2px !important',
  },
  onlypl: {
    paddingRight: '0px !important',
    paddingTop: '0px !important',
    paddingBottom: '0px !important',
  },
  cell: {
    padding: '0px 2px',
  },
  nob: {
    border: '0px !important',
    padding: '0.1rem',
  },
  sbb: {
    borderBottom: '1px solid rgba(0, 0, 0, 0.5) !important',
    padding: '0.1rem',
  },
  sbt: {
    borderTop: '1px solid rgba(0, 0, 0, 0.5) !important',
    padding: '0.1rem',
  },
  sbr: {
    padding: '0.01rem',
  },
  nobb: {
    borderBottom: '0px !important',
    padding: '0.1rem',
  },
  nobl: {
    borderLeft: '0px !important',
    padding: '0.1rem',
  },
  nobr: {
    borderRight: '0px !important',
    padding: '0.1rem',
  },
  nobt: {
    borderTop: '0px !important',
    padding: '0.1rem',
  },
  pointer: {
    cursor: 'pointer',
    verticalAlign: 'text-bottom',
  },
  pr5: {
    paddingRight: '0.25rem',
  },
  hidden: {
    // display: 'none'
  },
  highlight: {
    background: '#ffdf50',
    display: 'inline-block',
    /*paddingLeft: '5px',
    paddingRight: '5px',*/
  },
  upHighlight: {
    background: '#ffdf50',
    display: 'inline-block',
    /*paddingLeft: '5px',
    paddingRight: '5px',
    position: 'relative',
    minWidth: '27px',
    '&::after': {
      content: `''`,
      position: 'absolute',
      left: '1px',
      top: '3px',
      width: '10px',
      height: '7px',
      backgroundImage: `url(${require("../img/up.png")})`,
    }*/
  },
  downHighlight: {
    background: '#ffdf50',
    display: 'inline-block',
    /*paddingLeft: '5px',
    paddingRight: '5px',
    position: 'relative',
    minWidth: '27px',
    '&::after': {
      content: `''`,
      position: 'absolute',
      left: '1px',
      top: '4px',
      width: '10px',
      height: '6px',
      backgroundImage: `url(${require("../img/down.png")})`,
    }*/
  },
  extremes: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '99%',
    margin: '0 auto',
    color: '#1452CC',
    fontWeight: 'bold',
    fontSize: '13px',
  },
  handicap: {
    color: '#323030',
  },
  compName: {
    lineHeight: '16px',
    fontWeight: 'normal',
    fontSize: '14px',
    color: '#323030',
    backgroundColor: '#DEDEDE',
    borderBottom: '1px solid #86898C',
    borderTop: '1px solid #86898C',
    borderLeft: '1px solid #979d9d',
  },
  oddRow: {
    borderLeft: '1px solid #979d9d',
    borderRight: '1px solid #979d9d',
  },
  score: {
    color: '#DC252F',
    fontSize: '14px',
    fontWeight: 'bold',
  },
  time: {
    color: '#1452CC',
    fontSize: '11px',
    // fontWeight: 'bold',
    margin: '0.25rem 0 !important',
  },
  homeTeam: {
    color: '#DC252F',
    fontSize: '14px',
    textAlign: 'left',
    padding: '0 0.25rem',
  },
  awayTeam: {
    color: '#323030',
    fontSize: '14px',
    padding: '0 0.25rem',
    textAlign: 'left',
  },
  draw: {
    color: '#1452CC',
    textAlign: 'right',
    fontWeight: 'bold',
    padding: '0 0.25rem',
  },
  more: {
    color: '#1452CC',
    fontWeight: 'bold',
    fontSize: '13px',
  },
  corners: {
    height: '15px',
    fontSize: '14px',
    textAlign: 'left',
    padding: '0.5rem',
    fontWeight: 'bold',
    borderBottom: '1px solid #86898C !important',
    borderTop: '1px solid #86898C !important',
  },
  clickAble: {
    // textDecoration: 'underline',
    cursor: 'pointer',
  },
  redBox: {
    color: '#fff',
    paddingLeft: '0.1rem',
    paddingRight: '0.1rem',
    backgroundColor: '#DC252F',
    fontSize: '12px',
  },
  cameraIcon: {
    borderRadius: '100%',
    height: '30px',
    width: '30px',
    backgroundColor: 'transparent',
    border: '0',
    cursor: 'pointer',
  },
}));
const TableInfo = ({
  User,
  matches,
  line,
  setQuote,
  ParlayInfo,
  setParlayInfo,
  setBetParlay,
  betSuccess,
  setbetSuccess,
  setOddError,
  setOddUpdating,
  isParlayTable,
  setAddParlay,
  getMenu,
}) => {
  const { t } = useTranslation();
  const history = useHistory();
  const [preventDoubleClick, setPreventDoubleClick] = useState(false);
  const [quoteIdTimeout, setQuoteIdTimeout] = useState('');

  const inlinestyles = {
    nobb: {
      borderBottom: `0px`,
    },
    nobt: {
      borderTop: `0px !important`,
    }
  };

  useEffect(() => {
    if (!ParlayInfo) {
      let pq = localStorage.getItem('parlayQuote');
      if (pq) {
        pq = JSON.parse(pq);
        setParlayInfo(pq);
      }
    }
  }, []);

  const handleOdd = (Id, e) => {
    if (!User) {
      toast.dark('Please login to continue !', {
        position: 'top-right',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      return;
    }
    if (preventDoubleClick) {
      return;
    }

    setPreventDoubleClick(true);

    setQuote(null);
    setOddError(false);
    setOddUpdating(false);

    const odd = Id;
    const pick = e.target.id;
    //fetching quote to render left side
    if (!isParlayTable) {
      const requestBody = {
        odd: odd,
        pick: pick,
      };
      axiosInstance
        .post('restricted/quote', qs.stringify(requestBody))
        .then((res) => {
          //console.log(res.data);
          setQuote(res.data);
          document.querySelector('#betMoney').focus();
          setbetSuccess(false);
          if(quoteIdTimeout) {
            clearTimeout(quoteIdTimeout);
          }
          let timeout = setTimeout(() => {
            setQuoteIdTimeout('');
            if (document.querySelector("#quoteId") != null) {
              // only close the popup if quote id is still the same
              if (document.querySelector('#quoteId').value === res.data.quote) {
                setQuote(null);
              }
            }
          }, 120000);
          setQuoteIdTimeout(timeout);
        })
        .catch((err) => {
          console.log(err);
          if (err.response && err.response.data.status === 401) {
            logout(history);
          } else {
            setOddError(true);
            setQuote('');
          }
        })
        .finally(() => {
          setPreventDoubleClick(false);
        });
    } else {
      //logic for parley (do not reuse the logic below this crucial..)
      const parlayBody = {
        odd: odd,
        pick: pick,
        quote: ParlayInfo !== null ? ParlayInfo.quote : '',
      };
      axiosInstance
        .post('restricted/parlay', qs.stringify(parlayBody))
        .then((res) => {
          setOddError(false);
          console.info('set odd error to false');
          if (ParlayInfo !== null) {
            setAddParlay(true);
          }
          setParlayInfo(res.data);
          localStorage.setItem('parlayQuote', JSON.stringify(res.data));
          if (res.data.rejectReason) setOddUpdating(true);
          //console.log(res.data);
          // console.log(res.data.parlays.length);
          setbetSuccess(false);
          setBetParlay(true);

          if (document.querySelector('#betMoney'))
            document.querySelector('#betMoney').focus();
        })
        .catch((err) => {
          console.error(err);
          if (err.response && err.response.data.status === 401) {
            logout(history);
          } else {
            console.info('odd error');
            setParlayInfo({ parlays: [], types: [] });
            setOddError(true);
            setbetSuccess(false);
            setBetParlay(true);
          }
        })
        .finally(() => {
          setPreventDoubleClick(false);
        });
    }
  };

  const favMatch = (match, action) => {
    axiosInstance
      .post(
        'restricted/favorite',
        qs.stringify({
          add: action,
          match: match,
        })
      )
      .then((res) => {
        // TODO: Show notification toaster
      })
      .catch((err) => {
        console.log(err);
        if (err.response && err.response.data.status === 401) {
          logout(history);
        }
      });
  };

  const favLeague = (league, action) => {
    axiosInstance
      .post(
        'restricted/favorite',
        qs.stringify({
          add: action,
          comp: league,
        })
      )
      .then((res) => {
        // TODO: Show notification toaster
      })
      .catch((err) => {
        console.log(err);
        if (err.response && err.response.data.status === 401) {
          logout(history);
        }
      });
  };

  // const toggleVideo = () => {
  //   // if the element exists check if the id matched with the selected iframe if
  //   // matched then remove otherwise create new
  //   let selectedIframe = document.getElementById('iframe-video');
  //   if (selectedIframe) {
  //     selectedIframe.remove();
  //     // let iframeRow = document.getElementById(`tr${id}`)
  //     // iframeRow.setAttribute('class','d-none')
  //   } else {
  //     // let iframeRow = document.getElementById(`tr${id}`)
  //     // iframeRow.setAttribute('class','d-table-row')
  //     let iframeWrapper = document.getElementById('video-wrapper');
  //     let iframe = document.createElement('iframe');
  //     let obj = {
  //       src: 'https://live.spanner99.com/?openid=6e0c26bb0161ced463ca4760e9c99a03',
  //       height: '500',
  //       width: '750',
  //       allowFullScreen: true,
  //       frameborder: '0',
  //       id: `iframe-video`,
  //     };
  //     function setAttributes(el, attrs) {
  //       for (let key in attrs) {
  //         el.setAttribute(key, attrs[key]);
  //       }
  //     }
  //     setAttributes(iframe, obj);
  //     iframeWrapper.appendChild(iframe);
  //   }
  //   console.log('continue');
  // };

  const handleMatchModal = (match) => {
    // check for link from twitch
    let mt = '';
    if(match.tm) {
      mt = `${match.tm[0]} vs ${match.tm[1]}`;
    }
    window.open(`/video/${match.mf[0]}`, '_blank', 'noreferrer')
  };

  const [updateComponent, setUpdateComponent] = useState(new Date());

  const classes = useStyles();
  return (
    <>
      {line === 'Double' && updateComponent ? (
        <table className="oddsTable">
          <thead>
            <tr className="main-row">
              <th
                rowSpan="2"
                className={classes.name}
                style={{ borderRadius: '4px 0 0 0', borderLeft: 'none' }}
              >
                Time
              </th>
              <th rowSpan="2" className={classes.event}>
                Home/Away
              </th>
              <th colSpan="3" className={classes.fullTime}>
                Full Time
              </th>
              <th colSpan="3" className={classes.halfTime}>
                First Half
              </th>
              <th
                rowSpan="2"
                className={classes.more}
                style={{ borderRadius: ' 0 4px  0 0', borderRight: 'none' }}
              >
                Fav
              </th>
            </tr>
            <tr className="row2">
              <th>Handicap</th>
              <th>Over/Under</th>
              <th>{getMenu('Game') === 'Basketball' ? 'OE' : '1 X 2'}</th>
              <th>Handicap</th>
              <th>Over/Under</th>
              <th>{getMenu('Game') === 'Basketball' ? 'OE' : '1 X 2'}</th>
            </tr>
          </thead>
          {matches && matches.length === 0 ? (
            <tbody>
              <tr>
                <td colSpan="9">
                  <span className={`lang-${localStorage.getItem('language')}`}>
                    {t('No matches at the moment')}
                  </span>
                </td>
              </tr>
            </tbody>
          ) : null}

          {matches &&
            matches.map((match, index) => (
              <React.Fragment key={index}>
                <tbody className="trhover">
                  {match.l === undefined ? null : match.l !== '' &&
                    match.l !== 'Total Corners' &&
                    match.l !== 'Total Bookings' &&
                    match.l !== 'Yellow Cards' ? (
                    <>
                      {/* competition name */}
                      <tr className={classes.compName}>
                        <th colSpan="9" style={{ padding: '0.1rem' }}>
                          <span className={classes.pr5}>
                            {match.l}
                            {match.lr ? ' (' + match.lr + ')' : null}{' '}
                          </span>
                          {User ? (
                            <>
                              {match.lf &&
                              match.lf.length > 1 &&
                              match.lf[1] ? (
                                <svg
                                  onClick={() => {
                                    match.lf[1] = 0;
                                    setUpdateComponent(new Date());
                                    favLeague(match.lf[0], 0);
                                  }}
                                  className={classes.pointer}
                                  width="16"
                                  height="16"
                                  viewBox="0 0 8 8"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M4 0.0960693L4.94433 3.00207H8L5.52767 4.7984L6.472 7.7044L4 5.9084L1.52767 7.7044L2.472 4.7984L0 3.00207H3.05567L4 0.0960693Z"
                                    fill="#FAB81D"
                                  />
                                </svg>
                              ) : (
                                <svg
                                  onClick={() => {
                                    match.lf[1] = 1;
                                    setUpdateComponent(new Date());
                                    favLeague(match.lf[0], 1);
                                  }}
                                  className={classes.pointer}
                                  width="16"
                                  height="16"
                                  viewBox="0 0 8 8"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <mask id="path-1-inside-1" fill="white">
                                    <path d="M4 1.72422L4.77833 3.32989L6.54667 3.57389L5.25967 4.81056L5.57367 6.56722L4 5.72589L2.42633 6.56756L2.74033 4.81089L1.45333 3.57422L3.22167 3.32989L4 1.72422ZM4 0.195557L2.77733 2.71822L0 3.10189L2.02133 5.04456L1.528 7.80422L4 6.48189L6.472 7.80389L5.97867 5.04422L8 3.10189L5.22267 2.71856L4 0.195557Z" />
                                  </mask>
                                  <path
                                    d="M4 1.72422L4.77833 3.32989L6.54667 3.57389L5.25967 4.81056L5.57367 6.56722L4 5.72589L2.42633 6.56756L2.74033 4.81089L1.45333 3.57422L3.22167 3.32989L4 1.72422ZM4 0.195557L2.77733 2.71822L0 3.10189L2.02133 5.04456L1.528 7.80422L4 6.48189L6.472 7.80389L5.97867 5.04422L8 3.10189L5.22267 2.71856L4 0.195557Z"
                                    fill="#323030"
                                  />
                                  <path
                                    d="M4.77833 3.32989L3.87848 3.76609L4.11179 4.24739L4.64165 4.3205L4.77833 3.32989ZM6.54667 3.57389L7.23953 4.29496L8.72736 2.86531L6.68335 2.58328L6.54667 3.57389ZM5.25967 4.81056L4.5668 4.08949L4.18116 4.46004L4.27527 4.98652L5.25967 4.81056ZM5.57367 6.56722L5.10219 7.4491L6.92096 8.42147L6.55806 6.39126L5.57367 6.56722ZM4 5.72589L4.47148 4.84401L3.99991 4.59189L3.52837 4.84409L4 5.72589ZM2.42633 6.56756L1.44194 6.3916L1.07896 8.42223L2.89796 7.44935L2.42633 6.56756ZM2.74033 4.81089L3.72473 4.98685L3.81884 4.46038L3.4332 4.08982L2.74033 4.81089ZM1.45333 3.57422L1.31646 2.58363L-0.727012 2.86598L0.760467 4.29529L1.45333 3.57422ZM3.22167 3.32989L3.35854 4.32048L3.88826 4.24729L4.12152 3.76609L3.22167 3.32989ZM2.77733 2.71822L2.91418 3.70882L3.44395 3.63563L3.67721 3.15437L2.77733 2.71822ZM0 3.10189L-0.136843 2.1113L-2.18014 2.39356L-0.692938 3.82289L0 3.10189ZM2.02133 5.04456L3.00573 5.22053L3.09983 4.69412L2.71427 4.32356L2.02133 5.04456ZM1.528 7.80422L0.543606 7.62825L0.180562 9.65908L1.99968 8.68599L1.528 7.80422ZM4 6.48189L4.47159 5.60007L3.99994 5.34784L3.52832 5.60012L4 6.48189ZM6.472 7.80389L6.00041 8.68571L7.81939 9.65848L7.45639 7.62791L6.472 7.80389ZM5.97867 5.04422L5.28579 4.32317L4.90016 4.69373L4.99427 5.2202L5.97867 5.04422ZM8 3.10189L8.69288 3.82295L10.1806 2.39338L8.13673 2.11128L8 3.10189ZM5.22267 2.71856L4.32277 3.15465L4.55605 3.63603L5.08594 3.70917L5.22267 2.71856ZM3.10015 2.16042L3.87848 3.76609L5.67819 2.89369L4.89985 1.28803L3.10015 2.16042ZM4.64165 4.3205L6.40998 4.5645L6.68335 2.58328L4.91502 2.33928L4.64165 4.3205ZM5.8538 2.85282L4.5668 4.08949L5.95253 5.53162L7.23953 4.29496L5.8538 2.85282ZM4.27527 4.98652L4.58927 6.74318L6.55806 6.39126L6.24406 4.6346L4.27527 4.98652ZM6.04515 5.68535L4.47148 4.84401L3.52852 6.60777L5.10219 7.4491L6.04515 5.68535ZM3.52837 4.84409L1.95471 5.68576L2.89796 7.44935L4.47163 6.60769L3.52837 4.84409ZM3.41073 6.74351L3.72473 4.98685L1.75594 4.63493L1.44194 6.3916L3.41073 6.74351ZM3.4332 4.08982L2.1462 2.85316L0.760467 4.29529L2.04747 5.53196L3.4332 4.08982ZM1.5902 4.56481L3.35854 4.32048L3.0848 2.3393L1.31646 2.58363L1.5902 4.56481ZM4.12152 3.76609L4.89985 2.16042L3.10015 1.28803L2.32182 2.89369L4.12152 3.76609ZM3.10012 -0.240589L1.87746 2.28208L3.67721 3.15437L4.89988 0.631702L3.10012 -0.240589ZM2.64049 1.72763L-0.136843 2.1113L0.136843 4.09248L2.91418 3.70882L2.64049 1.72763ZM-0.692938 3.82289L1.3284 5.76555L2.71427 4.32356L0.692938 2.38089L-0.692938 3.82289ZM1.03694 4.86858L0.543606 7.62825L2.51239 7.9802L3.00573 5.22053L1.03694 4.86858ZM1.99968 8.68599L4.47168 7.36366L3.52832 5.60012L1.05632 6.92245L1.99968 8.68599ZM3.52841 7.36371L6.00041 8.68571L6.94359 6.92207L4.47159 5.60007L3.52841 7.36371ZM7.45639 7.62791L6.96306 4.86825L4.99427 5.2202L5.48761 7.97987L7.45639 7.62791ZM6.67154 5.76528L8.69288 3.82295L7.30712 2.38083L5.28579 4.32317L6.67154 5.76528ZM8.13673 2.11128L5.35939 1.72795L5.08594 3.70917L7.86327 4.0925L8.13673 2.11128ZM6.12257 2.28246L4.8999 -0.240542L3.1001 0.631655L4.32277 3.15465L6.12257 2.28246Z"
                                    fill="#323030"
                                    mask="url(#path-1-inside-1)"
                                  />
                                </svg>
                              )}
                            </>
                          ) : (
                            ''
                          )}
                        </th>
                      </tr>
                    </>
                  ) : null}
                  {match.l !== '' &&
                  (match.l === 'Total Corners' ||
                    match.l === 'Total Bookings' ||
                    match.l === 'Yellow Cards') ? (
                    <>
                      {/* total corners */}
                      <tr className={classes.oddRow}>
                        <th className={`${classes.corners}`} colSpan="9">
                          {match.l}
                        </th>
                      </tr>
                    </>
                  ) : null}
                  {/* 1st row */}
                  <tr className={classes.oddRow}>
                    <td 
                      width="6%"
                      className={`${classes.nobl} ${match.y ? classes.nobb : classes.sbb} ${classes.sbr} nobb ${match.x ? classes.nobt : classes.sbt} ${match.s || match.d ? '':'nobt'}`}
                      rowSpan={
                        match.tm === undefined
                          ? 2
                          : match.l === 'Total Corners'
                          ? 2
                          : match.o3 !== undefined // use match o3 to filter instead
                          ? match.tm.length - 1
                          : 2
                      }
                    >
                      {match.tm === undefined ? null : match.s === undefined ? (
                        <>
                          <p>{match.d && match.d[0]}</p>
                          <p>{match.d && match.d[1]}</p>
                        </>
                      ) : (
                        <>
                          <p className={classes.score}>
                            {match.s[0]}-{match.s[1]}
                          </p>
                          <p className={classes.time}>
                            {match.s[3] === 1 &&
                            match.hm &&
                            match.s[2] > match.hm
                              ? match.hm + '+ mins' // custom ht minuite
                              : match.s[3] === 1 && match.s[2] > 45
                              ? '45+ mins'
                              : null}
                            {match.s[3] === 2 &&
                            match.hm &&
                            match.s[2] > match.hm * 2
                              ? match.hm * 2 + '+ mins' // custom ht minuite
                              : match.s[3] === 2 && match.s[2] > 90
                              ? '90+ mins'
                              : null}
                            {match.s[3] === 3 &&
                            match.em &&
                            match.s[2] > match.em
                              ? match.em + '+ mins' // custom ht minuite
                              : match.s[3] === 3 && match.s[2] > 15
                              ? '15+ mins'
                              : null}
                            {match.s[3] === 4 &&
                            match.em &&
                            match.s[2] > match.em * 2
                              ? match.em * 2 + '+ mins' // custom ht minuite
                              : match.s[3] === 4 && match.s[2] > 30
                              ? '30+ mins'
                              : null}
                            {(match.s[3] === 2 &&
                              match.s[2] <= (match.hm ? match.hm * 2 : 90)) ||
                            (match.s[3] === 1 &&
                              match.s[2] <= (match.hm ? match.hm : 45)) ||
                            (match.s[3] === 3 &&
                              match.s[2] <= (match.em ? match.em : 15)) ||
                            (match.s[3] === 4 &&
                              match.s[2] <= (match.em ? match.em * 2 : 30))
                              ? match.s[2] + ' mins'
                              : null}
                            {match.s[3] === 5 ? 'HT' : null}
                          </p>
                          {/* <button onClick={() => toggleVideo(index)}  className={classes.cameraIcon}>
                          <img src={require('../img/camera.png')} alt="" style={{width:'100%'}} />
                          </button> */}
                          {match.tv && (
                            <button
                              onClick={() => handleMatchModal(match)}
                              className={classes.cameraIcon}
                            >
                              {/* <img
                                src={require('../img/camera.png')}
                                alt=""
                                style={{ width: '100%' }}
                              /> */}
                              <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M21.0254 8.40554C20.7987 8.20998 20.5218 8.09678 20.3141 8.02584C20.0833 7.94703 19.8184 7.88184 19.5383 7.82624C18.9764 7.71473 18.2727 7.62624 17.4908 7.55704C15.9221 7.41822 13.955 7.34998 12 7.34998C10.045 7.34997 8.0779 7.41821 6.50923 7.55704C5.7273 7.62623 5.02357 7.71473 4.46174 7.82624C4.18161 7.88184 3.91672 7.94703 3.68594 8.02583C3.4782 8.09677 3.20126 8.20998 2.97462 8.40553C2.76112 8.58976 2.63916 8.81815 2.56971 8.97159C2.49263 9.14189 2.43333 9.32752 2.38581 9.50895C2.29052 9.87283 2.21854 10.3144 2.16365 10.7872C2.05319 11.7386 2 12.9242 2 14.1032C2 15.283 2.05326 16.4858 2.16311 17.4726C2.21784 17.9643 2.28883 18.4229 2.38053 18.807C2.46043 19.1416 2.59126 19.5854 2.85131 19.906C3.08981 20.2 3.43086 20.3352 3.60561 20.3981C3.82965 20.4789 4.09015 20.5429 4.36115 20.596C4.90739 20.703 5.60964 20.7873 6.39637 20.853C7.97657 20.9851 9.99449 21.05 12 21.05C14.0055 21.05 16.0234 20.9851 17.6036 20.853C18.3904 20.7873 19.0926 20.703 19.6388 20.596C19.9098 20.5429 20.1703 20.4789 20.3944 20.3981C20.5691 20.3352 20.9102 20.2 21.1487 19.906C21.4087 19.5854 21.5396 19.1416 21.6195 18.807C21.7112 18.4229 21.7822 17.9643 21.8369 17.4726C21.9467 16.4858 22 15.283 22 14.1032C22 12.9242 21.9468 11.7386 21.8363 10.7872C21.7815 10.3144 21.7095 9.87284 21.6142 9.50896C21.5667 9.32752 21.5074 9.14189 21.4303 8.9716C21.3608 8.81815 21.2389 8.58976 21.0254 8.40554Z" stroke="#333333" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                              <line x1="11.4858" y1="6.44995" x2="8.39999" y2="3.36416" stroke="#333333" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                              <line x1="1" y1="-1" x2="5.36396" y2="-1" transform="matrix(0.707107 -0.707107 -0.707107 -0.707107 11.1 6.44995)" stroke="#333333" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                              </svg>
                            </button>
                          )}
                        </>
                      )}
                    </td>
                    <td
                      width="26%"
                      className={`${classes.sbr} ${
                        match.x ? classes.nobt : classes.sbt
                      } ${classes.nobb} ${(match.s === undefined && match.d === undefined) ||
                        match.tm === undefined ? classes.nobt: ''}`}
                      rowSpan={
                        (match.s === undefined && match.d === undefined) ||
                        match.tm === undefined
                          ? 2
                          : 1
                      }
                    >
                      {(match.s === undefined && match.d === undefined) ||
                      match.tm === undefined ? null : (
                        <>
                          <p
                            className={`${classes.cell} 
                      ${
                        match.old &&
                        match.old.tm &&
                        match.tm[0] &&
                        match.tm[0] !== match.old.tm[0]
                          ? classes.highlight
                          : ''
                      } 
                      ${
                        match.tm[3] === '1'
                          ? classes.homeTeam
                          : classes.awayTeam
                      }`}
                          >
                            {match.tm[0]}{' '}
                            {match.s !== undefined &&
                            match.s.length > 4 &&
                            match.s[4] > 0 ? (
                              <span className={classes.redBox}>
                                {match.s[4]}
                              </span>
                            ) : null}
                          </p>
                        </>
                      )}
                    </td>
                    <td
                      width="12%"
                      className={`${classes.sbr} ${
                        match.x ? classes.nobt : classes.sbt
                      }`}
                    >
                      
                      <div className={classes.extremes}>
                        <p
                          className={`${classes.cell} 
                  ${
                    // match.tv && match.tv.includes('saba166.com')? classes.hidden :
                    match.old &&
                    match.old.o1 &&
                    match.o1[0] &&
                    match.o1[0] !== match.old.o1[0]
                      ? classes.highlight
                      : ''
                  } 
                  ${classes.handicap}`}
                        >
                          {match.o1[0].replace('-', '')}
                        </p>
                        {/* odd = [match.p] and pick = 'H' */}
                        <p
                          id="H"
                          onClick={(e) => {
                            handleOdd(match.p, e);
                          }}
                          className={`${classes.cell} 
                    ${
                      // match.tv && match.tv.includes('saba166.com')? classes.hidden :
                      match.old &&
                      match.old.o1 &&
                      match.o1[1] &&
                      match.o1[1] !== match.old.o1[1]
                        ? classes.highlight
                        : ''
                    } 
                    ${classes.clickAble}
                    ${match.o1[1] < 0 ? classes.red : ''}
                    `}
                        >
                          {match.o1[1]}
                        </p>
                      </div>
                    </td>
                    <td
                      width="12%"
                      className={`${classes.sbr} ${
                        match.x ? classes.nobt : classes.sbt
                      }`}
                    >
                      <div className={classes.extremes}>
                        <p
                          className={`${classes.cell} 
                  ${
                    // match.tv && match.tv.includes('saba166.com')? classes.hidden :
                    match.old &&
                    match.old.o1 &&
                    match.o1[2] &&
                    match.o1[2] !== match.old.o1[2]
                      ? classes.highlight
                      : ''
                  }                   
                  ${classes.handicap}
                  ${match.o1[2] < 0 ? classes.red : ''}
                  `}
                        >
                          {match.o1[2]}
                        </p>
                        {/* odd = [match.p] and pick = 'O' */}
                        <p
                          id="O"
                          onClick={(e) => {
                            handleOdd(match.p, e);
                          }}
                          className={`${classes.cell} 
                    ${
                      // match.tv && match.tv.includes('saba166.com')? classes.hidden :
                      match.old &&
                      match.old.o1 &&
                      match.o1[3] &&
                      match.o1[3] !== match.old.o1[3]
                        ? classes.highlight
                        : ''
                    } 
                    ${classes.clickAble}
                    ${match.o1[3] < 0 ? classes.red : ''}
                    `}
                        >
                          {match.o1[3]}
                        </p>
                      </div>
                    </td>
                    <td
                      width="7%"
                      className={`${classes.sbr} ${
                        match.x ? classes.nobt : classes.sbt
                      }`}
                    >
                      {match.o3 !== undefined ? (
                        <p
                          id="HOME"
                          onClick={(e) => {
                            handleOdd(match.p, e);
                          }}
                          className={`${classes.more} ${classes.clickAble}
                    ${
                      // match.tv && match.tv.includes('saba166.com')? classes.hidden :
                      match.old &&
                      match.old.o1 &&
                      match.o1[4] &&
                      match.o1[4] !== match.old.o1[4]
                        ? classes.highlight
                        : ''
                    }
                    ${match.o1[4] < 0 ? classes.red : ''}
                    `}
                        >
                          {match.o1[4]}
                        </p>
                      ) : (
                        <p
                          id="ODD"
                          onClick={(e) => {
                            handleOdd(match.p, e);
                          }}
                          className={`${classes.more} ${classes.clickAble}
                    ${
                      // match.tv && match.tv.includes('saba166.com')? classes.hidden :
                      match.old &&
                      match.old.o1 &&
                      match.o1[4] &&
                      match.o1[4] !== match.old.o1[4]
                        ? classes.highlight
                        : ''
                    }                    
                    ${match.o1[4] < 0 ? classes.red : ''}
                    `}
                        >
                          {match.o1[4]}
                        </p>
                      )}
                    </td>
                    <td
                      width="12%"
                      className={`${classes.sbr} ${
                        match.x ? classes.nobt : classes.sbt
                      }`}
                    >
                      <div className={classes.extremes}>
                        <p
                          className={`${classes.cell} 
                  ${
                    // match.tv && match.tv.includes('saba166.com')? classes.hidden :
                    match.old &&
                    match.old.o1 &&
                    match.o1[5] &&
                    match.o1[5] !== match.old.o1[5]
                      ? classes.highlight
                      : ''
                  }                  
                  ${classes.handicap}`}
                        >
                          {match.o1[5].replace('-', '')}
                        </p>
                        {/* odd = [match.p] and pick = 'HTH' */}
                        <p
                          id="HTH"
                          onClick={(e) => {
                            handleOdd(match.p, e);
                          }}
                          className={`${classes.cell} 
                    ${
                      // match.tv && match.tv.includes('saba166.com')? classes.hidden :
                      match.old &&
                      match.old.o1 &&
                      match.o1[6] &&
                      match.o1[6] !== match.old.o1[6]
                        ? classes.highlight
                        : ''
                    }
                    ${classes.clickAble}
                    ${match.o1[6] < 0 ? classes.red : ''}
                    `}
                        >
                          {match.o1[6]}
                        </p>
                      </div>
                    </td>
                    <td
                      width="12%"
                      className={`${classes.sbr} ${
                        match.x ? classes.nobt : classes.sbt
                      }`}
                    >
                      <div className={classes.extremes}>
                        <p
                          className={`${classes.cell} 
                  ${
                    // match.tv && match.tv.includes('saba166.com')? classes.hidden :
                    match.old &&
                    match.old.o1 &&
                    match.o1[7] &&
                    match.o1[7] !== match.old.o1[7]
                      ? classes.highlight
                      : ''
                  }
                  ${classes.handicap}
                  ${match.o1[7] < 0 ? classes.red : ''}
                  `}
                        >
                          {match.o1[7]}
                        </p>
                        {/* odd = [match.p] and pick = 'HTO' */}
                        <p
                          id="HTO"
                          onClick={(e) => {
                            handleOdd(match.p, e);
                          }}
                          className={`${classes.cell} 
                    ${
                      // match.tv && match.tv.includes('saba166.com')? classes.hidden :
                      match.old &&
                      match.old.o1 &&
                      match.o1[8] &&
                      match.o1[8] !== match.old.o1[8]
                        ? classes.highlight
                        : ''
                    }
                    ${classes.clickAble}
                    ${match.o1[8] < 0 ? classes.red : ''}
                    `}
                        >
                          {match.o1[8]}
                        </p>
                      </div>
                    </td>
                    <td
                      width="7%"
                      className={`${classes.sbr} ${
                        match.x ? classes.nobt : classes.sbt
                      }`}
                    >
                      {match.o3 !== undefined ? (
                        <p
                          id="HTHOME"
                          onClick={(e) => {
                            handleOdd(match.p, e);
                          }}
                          className={`${classes.more} ${classes.clickAble}
                    ${
                      // match.tv && match.tv.includes('saba166.com')? classes.hidden :
                      match.old &&
                      match.old.o1 &&
                      match.o1[9] &&
                      match.o1[9] !== match.old.o1[9]
                        ? classes.highlight
                        : ''
                    }
                    ${match.o1[9] < 0 ? classes.red : ''}
                    `}
                        >
                          {match.o1[9]}
                        </p>
                      ) : (
                        <p
                          id="HTODD"
                          onClick={(e) => {
                            handleOdd(match.p, e);
                          }}
                          className={`${classes.more} ${classes.clickAble}
                          ${
                            // match.tv && match.tv.includes('saba166.com')? classes.hidden :
                    match.old &&
                    match.old.o1 &&
                    match.o1[9] &&
                    match.o1[9] !== match.old.o1[9]
                      ? classes.highlight
                      : ''
                  }                  
                  ${match.o1[9] < 0 ? classes.red : ''}
                  `}
                        >
                          {match.o1[9]}
                        </p>
                      )}
                    </td>
                    <td
                      width="6%"
                      className={`${classes.sbb} ${
                        match.x ? classes.nobt : classes.sbt
                      } ${match.y ? classes.nobb : classes.sbb} nobb ${
                        classes.nobr
                      } ${match.s || match.d ? '':'nobt'}`}
                      rowSpan={
                        match.tm === undefined
                          ? 2
                          : match.l === 'Total Corners'
                          ? 2
                          : match.o3 !== undefined
                          ? match.tm.length - 1
                          : 2
                      }
                    >
                      {match.tm === undefined ? null : (
                        <>
                          {User ? (
                            <p className={classes.more}>
                              {match.l !== 'Total Corners' &&
                              match.mf &&
                              match.mf.length > 1 &&
                              match.mf[1] ? (
                                <svg
                                  onClick={() => {
                                    match.mf[1] = 0;
                                    setUpdateComponent(new Date());
                                    favMatch(match.mf[0], 0);
                                  }}
                                  className={classes.pointer}
                                  width="16"
                                  height="16"
                                  viewBox="0 0 12 12"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M6 0.144043L7.4165 4.50304H12L8.2915 7.19754L9.708 11.5565L6 8.86254L2.2915 11.5565L3.708 7.19754L0 4.50304H4.5835L6 0.144043Z"
                                    fill="#FAB81D"
                                  />
                                </svg>
                              ) : match.l !== 'Total Corners' ? (
                                <svg
                                  onClick={() => {
                                    match.mf[1] = 1;
                                    setUpdateComponent(new Date());
                                    favMatch(match.mf[0], 1);
                                  }}
                                  className={classes.pointer}
                                  width="16"
                                  height="16"
                                  viewBox="0 0 12 12"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M6 2.58658L7.1675 4.99508L9.82 5.36108L7.8895 7.21608L8.3605 9.85108L6 8.58908L3.6395 9.85158L4.1105 7.21658L2.18 5.36158L4.8325 4.99508L6 2.58658ZM6 0.293579L4.166 4.07758L0 4.65308L3.032 7.56708L2.292 11.7066L6 9.72308L9.708 11.7061L8.968 7.56658L12 4.65308L7.834 4.07808L6 0.293579Z"
                                    fill="#FAB81D"
                                  />
                                </svg>
                              ) : (
                                ''
                              )}
                            </p>
                          ) : (
                            ''
                          )}
                        </>
                      )}
                    </td>
                  </tr>
                  {/* 2nd row */}
                  <tr className={classes.oddRow}>
                    {(match.s === undefined && match.d === undefined) ||
                    match.tm === undefined ? null : (
                      <>
                        <td className={`${classes.sbr} ${classes.nobt} ${classes.nobb}`}>
                          <p
                            className={
                              match.tm[3] === '2'
                                ? classes.homeTeam
                                : classes.awayTeam
                            }
                          >
                            {match.tm[1]}{' '}
                            {match.s !== undefined &&
                            match.s.length > 4 &&
                            match.s[5] > 0 ? (
                              <span className={classes.redBox}>
                                {match.s[5]}
                              </span>
                            ) : null}
                          </p>
                        </td>
                      </>
                    )}
                    <td
                      className={`${classes.sbr} ${
                        match.y && !(match.tm && match.tm.length === 4)
                          ? classes.nobb
                          : ''
                      } ${match.tm &&
                        match.tm.length === 4 &&
                        match.o3 !== undefined ? '':classes.sbb} `}
                    >
                      <div className={classes.extremes}>
                        <p
                          className={`${classes.cell} 
                          ${
                            // match.tv && match.tv.includes('saba166.com')? classes.hidden :
                    match.old &&
                    match.old.o2 &&
                    match.o2[0] &&
                    match.o2[0] !== match.old.o2[0]
                      ? classes.highlight
                      : ''
                  }
                  ${classes.handicap}
                  ${match.o2[0] < 0 ? classes.red : ''}
                  `}
                        >
                          {match.o2[0]}
                        </p>
                        {/* odd = [match.p] and pick = 'A' */}
                        <p
                          id="A"
                          onClick={(e) => {
                            handleOdd(match.p, e);
                          }}
                          className={`${classes.cell} 
                          ${
                            // match.tv && match.tv.includes('saba166.com')? classes.hidden :
                          match.old &&
                          match.old.o2 &&
                          match.o2[1] &&
                          match.o2[1] !== match.old.o2[1]
                            ? classes.highlight
                            : ''
                        } 
                    ${classes.clickAble}
                    ${match.o2[1] < 0 ? classes.red : ''}
                    `}
                        >
                          {match.o2[1]}
                        </p>
                      </div>
                    </td>
                    <td
                      className={`${classes.sbr} ${
                        match.y && !(match.tm && match.tm.length === 4)
                          ? classes.nobb
                          : ''
                      } ${match.tm &&
                        match.tm.length === 4 &&
                        match.o3 !== undefined ? '':classes.sbb}`}
                    >
                      <div className={classes.extremes}>
                        <p
                          className={`${classes.cell} 
                  ${classes.handicap}
                  ${match.o2[2] < 0 ? classes.red : ''}
                  `}
                        >
                          {match.o2[2]}
                        </p>
                        {/* odd = [match.p] and pick = 'U' */}
                        <p
                          id="U"
                          onClick={(e) => {
                            handleOdd(match.p, e);
                          }}
                          className={`${classes.cell} 
                    ${
                      // match.tv && match.tv.includes('saba166.com')? classes.hidden :
                      match.old &&
                      match.old.o2 &&
                      match.o2[3] &&
                      match.o2[3] !== match.old.o2[3]
                        ? classes.highlight
                        : ''
                    }
                    ${classes.clickAble}
                    ${match.o2[3] < 0 ? classes.red : ''}
                    `}
                        >
                          {match.o2[3]}
                        </p>
                      </div>
                    </td>
                    <td
                      className={`${classes.sbr} ${
                        match.y && !(match.tm && match.tm.length === 4)
                          ? classes.nobb
                          : ''
                      } ${match.tm &&
                        match.tm.length === 4 &&
                        match.o3 !== undefined ? '':classes.sbb}`}
                    > 
                      {match.o3 !== undefined ? (
                        <p
                          id="AWAY"
                          onClick={(e) => {
                            handleOdd(match.p, e);
                          }}
                          className={`${classes.more} ${classes.clickAble}
                  ${
                    // match.tv && match.tv.includes('saba166.com')? classes.hidden :
                    match.old &&
                    match.old.o2 &&
                    match.o2[4] &&
                    match.o2[4] !== match.old.o2[4]
                      ? classes.highlight
                      : ''
                  }
                  ${match.o2[4] < 0 ? classes.red : ''}
                  `}
                        >
                          {match.o2[4]}
                        </p>
                      ) : (
                        <p
                          id="EVEN"
                          onClick={(e) => {
                            handleOdd(match.p, e);
                          }}
                          className={`${classes.more} ${classes.clickAble}
                ${
                  // match.tv && match.tv.includes('saba166.com')? classes.hidden :
                  match.old &&
                  match.old.o2 &&
                  match.o2[4] &&
                  match.o2[4] !== match.old.o2[4]
                    ? classes.highlight
                    : ''
                }
                ${match.o2[4] < 0 ? classes.red : ''}
                `}
                        >
                          {match.o2[4]}
                        </p>
                      )}
                    </td>
                    <td
                      className={`${classes.sbr} ${
                        match.y && !(match.tm && match.tm.length === 4)
                          ? classes.nobb
                          : ''
                      } ${match.tm &&
                        match.tm.length === 4 &&
                        match.o3 !== undefined ? '':classes.sbb}`}
                    >
                      <div className={classes.extremes}>
                        <p
                          className={`${classes.cell} 
                  ${
                    // match.tv && match.tv.includes('saba166.com')? classes.hidden :
                    match.old &&
                    match.old.o2 &&
                    match.o2[5] &&
                    match.o2[5] !== match.old.o2[5]
                      ? classes.highlight
                      : ''
                  }
                  ${classes.handicap}
                  ${match.o2[5] < 0 ? classes.red : ''}
                  `}
                        >
                          {match.o2[5]}
                        </p>
                        {/* odd = [match.p] and pick = 'HTA' */}
                        <p
                          id="HTA"
                          className={`${classes.cell} 
                    ${
                      // match.tv && match.tv.includes('saba166.com')? classes.hidden :
                      match.old &&
                      match.old.o2 &&
                      match.o2[6] &&
                      match.o2[6] !== match.old.o2[6]
                        ? classes.highlight
                        : ''
                    }
                    ${classes.clickAble}
                    ${match.o2[6] < 0 ? classes.red : ''}
                    `}
                          onClick={(e) => {
                            handleOdd(match.p, e);
                          }}
                        >
                          {match.o2[6]}
                        </p>
                      </div>
                    </td>
                    <td
                      className={`${classes.sbr} ${
                        match.y && !(match.tm && match.tm.length === 4)
                          ? classes.nobb
                          : ''
                      } ${match.tm &&
                        match.tm.length === 4 &&
                        match.o3 !== undefined ? '':classes.sbb}`}
                    >
                      <div className={classes.extremes}>
                        <p
                          className={`${classes.cell} 
                  ${classes.handicap}
                  ${match.o2[7] < 0 ? classes.red : ''}
                  `}
                        >
                          {match.o2[7]}
                        </p>
                        {/* odd = [match.p] and pick = 'HTU' */}
                        <p
                          id="HTU"
                          onClick={(e) => {
                            handleOdd(match.p, e);
                          }}
                          className={`${classes.cell} 
                    ${
                      // match.tv && match.tv.includes('saba166.com')? classes.hidden :
                      match.old &&
                      match.old.o2 &&
                      match.o2[8] &&
                      match.o2[8] !== match.old.o2[8]
                        ? classes.highlight
                        : ''
                    }
                    ${classes.clickAble}
                    ${match.o2[8] < 0 ? classes.red : ''}
                    `}
                        >
                          {match.o2[8]}
                        </p>
                      </div>
                    </td>
                    <td
                      className={`${classes.sbr} ${
                        match.y && !(match.tm && match.tm.length === 4)
                          ? classes.nobb
                          : ''
                      } ${match.tm &&
                        match.tm.length === 4 &&
                        match.o3 !== undefined ? '':classes.sbb}`}
                    >
                      {match.o3 !== undefined ? (
                        <p
                          id="HTAWAY"
                          onClick={(e) => {
                            handleOdd(match.p, e);
                          }}
                          className={`${classes.more} ${classes.clickAble}
                  ${
                    // match.tv && match.tv.includes('saba166.com')? classes.hidden :
                    match.old &&
                    match.old.o2 &&
                    match.o2[9] &&
                    match.o2[9] !== match.old.o2[9]
                      ? classes.highlight
                      : ''
                  }                  
                  ${match.o2[9] < 0 ? classes.red : ''}
                  `}
                        >
                          {match.o2[9]}
                        </p>
                      ) : (
                        <p
                          id="HTEVEN"
                          onClick={(e) => {
                            handleOdd(match.p, e);
                          }}
                          className={`${classes.more} ${classes.clickAble}
                  ${
                    // match.tv && match.tv.includes('saba166.com')? classes.hidden :
                    match.old &&
                    match.old.o2 &&
                    match.o2[9] &&
                    match.o2[9] !== match.old.o2[9]
                      ? classes.highlight
                      : ''
                  }
                  ${match.o2[9] < 0 ? classes.red : ''}
                  `}
                        >
                          {match.o2[9]}
                        </p>
                      )}
                    </td>
                  </tr>
                  {/* condition for 2 row  */}
                  {match.tm &&
                  match.tm.length === 4 &&
                  match.o3 !== undefined ? (
                    <>
                      {/* 3rd row */}
                      <tr className={classes.oddRow}>
                        <td 
                          className={` ${
                            match.y ? classes.nobb : classes.sbb
                          } ${classes.sbr} ${classes.nobt} nobb`}
                        >
                          <p
                            className={`${classes.cell} 
                    ${classes.draw}`}
                          >
                            {match.tm[2]}
                          </p>
                        </td>
                        <td
                          className={` ${
                            match.y ? classes.nobb : classes.sbb
                          } ${classes.sbr}`}
                        ></td>
                        <td
                          className={` ${
                            match.y ? classes.nobb : classes.sbb
                          } ${classes.sbr}`}
                        ></td>
                        <td
                          className={` ${
                            match.y ? classes.nobb : classes.sbb
                          } ${classes.sbr}`}
                        >
                          <p
                            id="DRAW"
                            onClick={(e) => {
                              handleOdd(match.p, e);
                            }}
                            className={`${classes.more} ${classes.clickAble}
                    ${
                      // match.tv && match.tv.includes('saba166.com')? classes.hidden :
                      match.old &&
                      match.old.o3 &&
                      match.o3[0] &&
                      match.o3[0] !== match.old.o3[0]
                        ? classes.highlight
                        : ''
                    }
                    ${match.o3 && match.o3[0] < 0 ? classes.red : ''}
                    `}
                          >
                            {match.o3 && match.o3[0]}
                          </p>
                        </td>
                        <td
                          className={` ${
                            match.y ? classes.nobb : classes.sbb
                          } ${classes.sbr}`}
                        ></td>
                        <td
                          className={` ${
                            match.y ? classes.nobb : classes.sbb
                          } ${classes.sbr}`}
                        ></td>
                        <td
                          className={` ${
                            match.y ? classes.nobb : classes.sbb
                          } ${classes.sbr}`}
                        >
                          <p
                            id="HTDRAW"
                            onClick={(e) => {
                              handleOdd(match.p, e);
                            }}
                            className={`${classes.more} ${classes.clickAble}
                    ${
                      // match.tv && match.tv.includes('saba166.com')? classes.hidden :
                      match.old &&
                      match.old.o3 &&
                      match.o3[1] &&
                      match.o3[1] !== match.old.o3[1]
                        ? classes.highlight
                        : ''
                    }
                    ${match.o3 && match.o3[1] < 0 ? classes.red : ''}
                    `}
                          >
                            {match.o3 && match.o3[1]}
                          </p>
                        </td>
                      </tr>
                    </>
                  ) : null}
                  <tr key={match.id} id={`tr${index}`} className="d-none">
                    <td colSpan={9}>
                      <div id={`td${index}`} className="table-flex">
                        <button
                          className={`${classes.cameraIcon} fullscreen-btn`}
                        >
                          <img
                            src={require('../img/fullscreen.png')}
                            alt=""
                            style={{ width: '100%' }}
                          />
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </React.Fragment>
            ))}
        </table>
      ) : (
        <table className="oddsTable singleline">
          <thead>
            <tr className="main-row">
              <th
                rowSpan="2"
                className={classes.name}
                style={{ borderRadius: '4px 0 0 0', borderLeft: 'none' }}
              >
                Time
              </th>
              <th rowSpan="2" className={classes.event}>
                Event
              </th>
              <th colSpan="6" className={classes.fullTime}>
                Full Time
              </th>
              <th colSpan="6" className={classes.halfTime}>
                First Half
              </th>
              <th
                rowSpan="2"
                className={classes.more}
                style={{ borderRadius: ' 0 4px  0 0', borderRight: 'none' }}
              >
                More
              </th>
            </tr>
            <tr className="row2">
              <th>HDP</th>
              <th>Home</th>
              <th>Away</th>
              <th>OU</th>
              <th>Over</th>
              <th>Under</th>
              <th>HDP</th>
              <th>Home</th>
              <th>Away</th>
              <th>OU</th>
              <th>Over</th>
              <th>Under</th>
            </tr>
          </thead>
          <tbody>
            {matches && matches.length === 0 ? (
              <tr>
                <td colSpan="15">
                  <span className={`lang-${localStorage.getItem('language')}`}>
                    {t('No matches at the moment')}
                  </span>
                </td>
              </tr>
            ) : null}
            {matches &&
              matches.map((match, index) => (
                <React.Fragment key={index}>
                  {match.l === undefined ? null : match.l !== '' &&
                    match.l !== 'Total Corners' &&
                    match.l !== 'Total Bookings' &&
                    match.l !== 'Yellow Cards' ? (
                    <>
                      {/* competition name */}
                      <tr className={classes.compName}>
                        <th className={classes.nob} colSpan="17">
                          {match.l}{' '}
                          {User ? (
                            <span>
                              {match.lf &&
                              match.lf.length > 1 &&
                              match.lf[1] ? (
                                <svg
                                  onClick={() => {
                                    match.lf[1] = 0;
                                    setUpdateComponent(new Date());
                                    favLeague(match.lf[0], 0);
                                  }}
                                  className={classes.pointer}
                                  width="16"
                                  height="16"
                                  viewBox="0 0 8 8"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M4 0.0960693L4.94433 3.00207H8L5.52767 4.7984L6.472 7.7044L4 5.9084L1.52767 7.7044L2.472 4.7984L0 3.00207H3.05567L4 0.0960693Z"
                                    fill="#FAB81D"
                                  />
                                </svg>
                              ) : (
                                <svg
                                  onClick={() => {
                                    match.lf[1] = 1;
                                    setUpdateComponent(new Date());
                                    favLeague(match.lf[0], 1);
                                  }}
                                  className={classes.pointer}
                                  width="16"
                                  height="16"
                                  viewBox="0 0 8 8"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <mask id="path-1-inside-1" fill="white">
                                    <path d="M4 1.72422L4.77833 3.32989L6.54667 3.57389L5.25967 4.81056L5.57367 6.56722L4 5.72589L2.42633 6.56756L2.74033 4.81089L1.45333 3.57422L3.22167 3.32989L4 1.72422ZM4 0.195557L2.77733 2.71822L0 3.10189L2.02133 5.04456L1.528 7.80422L4 6.48189L6.472 7.80389L5.97867 5.04422L8 3.10189L5.22267 2.71856L4 0.195557Z" />
                                  </mask>
                                  <path
                                    d="M4 1.72422L4.77833 3.32989L6.54667 3.57389L5.25967 4.81056L5.57367 6.56722L4 5.72589L2.42633 6.56756L2.74033 4.81089L1.45333 3.57422L3.22167 3.32989L4 1.72422ZM4 0.195557L2.77733 2.71822L0 3.10189L2.02133 5.04456L1.528 7.80422L4 6.48189L6.472 7.80389L5.97867 5.04422L8 3.10189L5.22267 2.71856L4 0.195557Z"
                                    fill="#323030"
                                  />
                                  <path
                                    d="M4.77833 3.32989L3.87848 3.76609L4.11179 4.24739L4.64165 4.3205L4.77833 3.32989ZM6.54667 3.57389L7.23953 4.29496L8.72736 2.86531L6.68335 2.58328L6.54667 3.57389ZM5.25967 4.81056L4.5668 4.08949L4.18116 4.46004L4.27527 4.98652L5.25967 4.81056ZM5.57367 6.56722L5.10219 7.4491L6.92096 8.42147L6.55806 6.39126L5.57367 6.56722ZM4 5.72589L4.47148 4.84401L3.99991 4.59189L3.52837 4.84409L4 5.72589ZM2.42633 6.56756L1.44194 6.3916L1.07896 8.42223L2.89796 7.44935L2.42633 6.56756ZM2.74033 4.81089L3.72473 4.98685L3.81884 4.46038L3.4332 4.08982L2.74033 4.81089ZM1.45333 3.57422L1.31646 2.58363L-0.727012 2.86598L0.760467 4.29529L1.45333 3.57422ZM3.22167 3.32989L3.35854 4.32048L3.88826 4.24729L4.12152 3.76609L3.22167 3.32989ZM2.77733 2.71822L2.91418 3.70882L3.44395 3.63563L3.67721 3.15437L2.77733 2.71822ZM0 3.10189L-0.136843 2.1113L-2.18014 2.39356L-0.692938 3.82289L0 3.10189ZM2.02133 5.04456L3.00573 5.22053L3.09983 4.69412L2.71427 4.32356L2.02133 5.04456ZM1.528 7.80422L0.543606 7.62825L0.180562 9.65908L1.99968 8.68599L1.528 7.80422ZM4 6.48189L4.47159 5.60007L3.99994 5.34784L3.52832 5.60012L4 6.48189ZM6.472 7.80389L6.00041 8.68571L7.81939 9.65848L7.45639 7.62791L6.472 7.80389ZM5.97867 5.04422L5.28579 4.32317L4.90016 4.69373L4.99427 5.2202L5.97867 5.04422ZM8 3.10189L8.69288 3.82295L10.1806 2.39338L8.13673 2.11128L8 3.10189ZM5.22267 2.71856L4.32277 3.15465L4.55605 3.63603L5.08594 3.70917L5.22267 2.71856ZM3.10015 2.16042L3.87848 3.76609L5.67819 2.89369L4.89985 1.28803L3.10015 2.16042ZM4.64165 4.3205L6.40998 4.5645L6.68335 2.58328L4.91502 2.33928L4.64165 4.3205ZM5.8538 2.85282L4.5668 4.08949L5.95253 5.53162L7.23953 4.29496L5.8538 2.85282ZM4.27527 4.98652L4.58927 6.74318L6.55806 6.39126L6.24406 4.6346L4.27527 4.98652ZM6.04515 5.68535L4.47148 4.84401L3.52852 6.60777L5.10219 7.4491L6.04515 5.68535ZM3.52837 4.84409L1.95471 5.68576L2.89796 7.44935L4.47163 6.60769L3.52837 4.84409ZM3.41073 6.74351L3.72473 4.98685L1.75594 4.63493L1.44194 6.3916L3.41073 6.74351ZM3.4332 4.08982L2.1462 2.85316L0.760467 4.29529L2.04747 5.53196L3.4332 4.08982ZM1.5902 4.56481L3.35854 4.32048L3.0848 2.3393L1.31646 2.58363L1.5902 4.56481ZM4.12152 3.76609L4.89985 2.16042L3.10015 1.28803L2.32182 2.89369L4.12152 3.76609ZM3.10012 -0.240589L1.87746 2.28208L3.67721 3.15437L4.89988 0.631702L3.10012 -0.240589ZM2.64049 1.72763L-0.136843 2.1113L0.136843 4.09248L2.91418 3.70882L2.64049 1.72763ZM-0.692938 3.82289L1.3284 5.76555L2.71427 4.32356L0.692938 2.38089L-0.692938 3.82289ZM1.03694 4.86858L0.543606 7.62825L2.51239 7.9802L3.00573 5.22053L1.03694 4.86858ZM1.99968 8.68599L4.47168 7.36366L3.52832 5.60012L1.05632 6.92245L1.99968 8.68599ZM3.52841 7.36371L6.00041 8.68571L6.94359 6.92207L4.47159 5.60007L3.52841 7.36371ZM7.45639 7.62791L6.96306 4.86825L4.99427 5.2202L5.48761 7.97987L7.45639 7.62791ZM6.67154 5.76528L8.69288 3.82295L7.30712 2.38083L5.28579 4.32317L6.67154 5.76528ZM8.13673 2.11128L5.35939 1.72795L5.08594 3.70917L7.86327 4.0925L8.13673 2.11128ZM6.12257 2.28246L4.8999 -0.240542L3.1001 0.631655L4.32277 3.15465L6.12257 2.28246Z"
                                    fill="#323030"
                                    mask="url(#path-1-inside-1)"
                                  />
                                </svg>
                              )}
                            </span>
                          ) : (
                            ''
                          )}
                        </th>
                      </tr>
                    </>
                  ) : null}
                  {match.l !== '' &&
                  (match.l === 'Total Corners' ||
                    match.l === 'Total Bookings' ||
                    match.l === 'Yellow Cards') ? (
                    <>
                      {/* total corners */}
                      <tr>
                        <th
                          className={`${classes.nob} ${classes.corners}`}
                          colSpan="17"
                        >
                          {match.l}
                        </th>
                      </tr>
                    </>
                  ) : null}
                  {/* 1st row */}
                  <tr>
                    <td
                      className={`${classes.singleCell} 
              ${match.x ? classes.nobt : ''} 
              ${match.y ? classes.nobb : ''}`}
                    >
                      {match.tm === undefined ? null : match.s === undefined ? (
                        <>
                          <p>{match.d[0]}</p>
                          <p>{match.d[1]}</p>
                        </>
                      ) : (
                        <>
                          <p className={classes.score}>
                            {match.s[0]}-{match.s[1]}
                          </p>
                          <p className={classes.time}>
                            {match.s[3] === 1 &&
                            match.hm &&
                            match.s[2] > match.hm
                              ? match.hm + '+ mins' // custom ht minuite
                              : match.s[3] === 1 && match.s[2] > 45
                              ? '45+ mins'
                              : null}
                            {match.s[3] === 2 &&
                            match.hm &&
                            match.s[2] > match.hm * 2
                              ? match.hm * 2 + '+ mins' // custom ht minuite
                              : match.s[3] === 2 && match.s[2] > 90
                              ? '90+ mins'
                              : null}
                            {match.s[3] === 3 &&
                            match.em &&
                            match.s[2] > match.em
                              ? match.em + '+ mins' // custom ht minuite
                              : match.s[3] === 3 && match.s[2] > 15
                              ? '15+ mins'
                              : null}
                            {match.s[3] === 4 &&
                            match.em &&
                            match.s[2] > match.em * 2
                              ? match.em * 2 + '+ mins' // custom ht minuite
                              : match.s[3] === 4 && match.s[2] > 30
                              ? '30+ mins'
                              : null}
                            {(match.s[3] === 2 &&
                              match.s[2] <= (match.hm ? match.hm * 2 : 90)) ||
                            (match.s[3] === 1 &&
                              match.s[2] <= (match.hm ? match.hm : 45)) ||
                            (match.s[3] === 3 &&
                              match.s[2] <= (match.em ? match.em : 15)) ||
                            (match.s[3] === 4 &&
                              match.s[2] <= (match.em ? match.em * 2 : 30))
                              ? match.s[2] + ' mins'
                              : null}
                            {match.s[3] === 5 ? 'HT' : null}
                          </p>
                          {match.tv && (
                            <button
                              onClick={() => handleMatchModal(match)}
                              className={classes.cameraIcon}
                            >
                              {/* <img
                                src={require('../img/camera.png')}
                                alt=""
                                style={{ width: '100%' }}
                              /> */}
                              <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M21.0254 8.40554C20.7987 8.20998 20.5218 8.09678 20.3141 8.02584C20.0833 7.94703 19.8184 7.88184 19.5383 7.82624C18.9764 7.71473 18.2727 7.62624 17.4908 7.55704C15.9221 7.41822 13.955 7.34998 12 7.34998C10.045 7.34997 8.0779 7.41821 6.50923 7.55704C5.7273 7.62623 5.02357 7.71473 4.46174 7.82624C4.18161 7.88184 3.91672 7.94703 3.68594 8.02583C3.4782 8.09677 3.20126 8.20998 2.97462 8.40553C2.76112 8.58976 2.63916 8.81815 2.56971 8.97159C2.49263 9.14189 2.43333 9.32752 2.38581 9.50895C2.29052 9.87283 2.21854 10.3144 2.16365 10.7872C2.05319 11.7386 2 12.9242 2 14.1032C2 15.283 2.05326 16.4858 2.16311 17.4726C2.21784 17.9643 2.28883 18.4229 2.38053 18.807C2.46043 19.1416 2.59126 19.5854 2.85131 19.906C3.08981 20.2 3.43086 20.3352 3.60561 20.3981C3.82965 20.4789 4.09015 20.5429 4.36115 20.596C4.90739 20.703 5.60964 20.7873 6.39637 20.853C7.97657 20.9851 9.99449 21.05 12 21.05C14.0055 21.05 16.0234 20.9851 17.6036 20.853C18.3904 20.7873 19.0926 20.703 19.6388 20.596C19.9098 20.5429 20.1703 20.4789 20.3944 20.3981C20.5691 20.3352 20.9102 20.2 21.1487 19.906C21.4087 19.5854 21.5396 19.1416 21.6195 18.807C21.7112 18.4229 21.7822 17.9643 21.8369 17.4726C21.9467 16.4858 22 15.283 22 14.1032C22 12.9242 21.9468 11.7386 21.8363 10.7872C21.7815 10.3144 21.7095 9.87284 21.6142 9.50896C21.5667 9.32752 21.5074 9.14189 21.4303 8.9716C21.3608 8.81815 21.2389 8.58976 21.0254 8.40554Z" stroke="#333333" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                              <line x1="11.4858" y1="6.44995" x2="8.39999" y2="3.36416" stroke="#333333" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                              <line x1="1" y1="-1" x2="5.36396" y2="-1" transform="matrix(0.707107 -0.707107 -0.707107 -0.707107 11.1 6.44995)" stroke="#333333" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                              </svg>
                            </button>
                          )}
                        </>
                      )}
                    </td>
                    <td
                      className={`${classes.singleCell} 
              ${match.x ? classes.nobt : ''} 
              ${match.y ? classes.nobb : ''}`}
                    >
                      {(match.s === undefined && match.d === undefined) ||
                      match.tm === undefined ? null : (
                        <>
                          <p
                            className={`
                        ${
                          match.tm[3] === '1'
                            ? classes.homeTeam
                            : classes.awayTeam
                        }`}
                          >
                            {match.tm[0]}{' '}
                            {match.s !== undefined &&
                            match.s.length > 4 &&
                            match.s[4] > 0 ? (
                              <span className={classes.redBox}>
                                {match.s[4]}
                              </span>
                            ) : null}
                          </p>
                        </>
                      )}
                      {(match.s === undefined && match.d === undefined) ||
                      match.tm === undefined ? null : (
                        <>
                          <p
                            className={`
                        ${
                          match.tm[3] === '2'
                            ? classes.homeTeam
                            : classes.awayTeam
                        }
                        ${classes.bottomEvent} 
                      `}
                          >
                            {match.tm[1]}{' '}
                            {match.s !== undefined &&
                            match.s.length > 4 &&
                            match.s[5] > 0 ? (
                              <span className={classes.redBox}>
                                {match.s[5]}
                              </span>
                            ) : null}
                          </p>
                        </>
                      )}
                    </td>
                    <td
                      className={`${classes.singleCell}  
              ${match.x ? classes.nobt : ''} 
              ${match.y ? classes.nobb : ''}`}
                    >
                      <div className={`${classes.singleExtremes}`}>
                        {match && match.o1 && match.o1[0] ? (
                          <p
                            className={` 
                    ${
                      // match.tv && match.tv.includes('saba166.com')? classes.hidden :
                      match.old &&
                      match.old.o1 &&
                      match.o1[0] &&
                      match.o1[0] !== match.old.o1[0]
                        ? classes.highlight
                        : ''
                    }                     
                    ${classes.handicap}
                    ${match.o1[0] < 0 ? classes.red : ''}
                    `}
                          >
                            {match.o1[0]}
                          </p>
                        ) : (
                          <p
                            className={` 
                            ${
                              // match.tv && match.tv.includes('saba166.com')? classes.hidden :
                      match.old &&
                      match.old.o2 &&
                      match.o2[0] &&
                      match.o2[0] !== match.old.o2[0]
                        ? classes.highlight
                        : ''
                    } 
                    ${classes.handicap}
                    ${match.o2[0] < 0 ? classes.red : ''}
                    `}
                          >
                            {match.o2[0]}
                          </p>
                        )}
                      </div>
                    </td>
                    <td
                      className={`${classes.singleCell} 
              ${match.x ? classes.nobt : ''} 
              ${match.y ? classes.nobb : ''}`}
                    >
                      <div className={classes.singleExtremes}>
                        <p
                          id="H"
                          onClick={(e) => {
                            handleOdd(match.p, e);
                          }}
                          className={`
                      ${
                        // match.tv && match.tv.includes('saba166.com')? classes.hidden :
                        match.old &&
                        match.old.o1 &&
                        match.o1[1] &&
                        match.o1[1] !== match.old.o1[1]
                          ? classes.highlight
                          : ''
                      } 
                      ${classes.clickAble}
                      ${match.o1[1] < 0 ? classes.red : ''}
                      `}
                        >
                          {match.o1[1]}
                        </p>
                      </div>
                    </td>
                    <td
                      className={`${classes.singleCell} 
                ${match.x ? classes.nobt : ''} 
                ${match.y ? classes.nobb : ''}`}
                    >
                      <div className={classes.singleExtremes}>
                        <p
                          id="A"
                          onClick={(e) => {
                            handleOdd(match.p, e);
                          }}
                          className={` 
                      ${
                        // match.tv && match.tv.includes('saba166.com')? classes.hidden :
                        match.old &&
                        match.old.o2 &&
                        match.o2[1] &&
                        match.o2[1] !== match.old.o2[1]
                          ? classes.highlight
                          : ''
                      }
                      ${classes.clickAble}
                      ${match.o2[1] < 0 ? classes.red : ''}
                      `}
                        >
                          {match.o2[1]}
                        </p>
                      </div>
                    </td>
                    <td
                      className={`${classes.singleCell} 
                ${match.x ? classes.nobt : ''} 
                ${match.y ? classes.nobb : ''}`}
                    >
                      <div className={`${classes.singleExtremes}`}>
                        <p
                          className={` 
                      ${
                        match.tv && match.tv.includes('saba166.com')? classes.hidden :
                        match.old &&
                        match.old.o1 &&
                        match.o1[2] &&
                        match.o1[2] !== match.old.o1[2]
                          ? classes.highlight
                          : ''
                      } 
                      ${classes.handicap}
                      ${match.o1[2] < 0 ? classes.red : ''}
                      `}
                        >
                          {match.o1[2]}
                        </p>
                      </div>
                    </td>
                    <td
                      className={`${classes.singleCell}
                ${match.x ? classes.nobt : ''} 
                ${match.y ? classes.nobb : ''}`}
                    >
                      <div className={classes.singleExtremes}>
                        <p
                          id="O"
                          onClick={(e) => {
                            handleOdd(match.p, e);
                          }}
                          className={` 
                      ${
                        // match.tv && match.tv.includes('saba166.com')? classes.hidden :
                        match.old &&
                        match.old.o1 &&
                        match.o1[3] &&
                        match.o1[3] !== match.old.o1[3]
                          ? classes.highlight
                          : ''
                      } 
                      ${classes.clickAble}
                      ${match.o1[3] < 0 ? classes.red : ''}
                      `}
                        >
                          {match.o1[3]}
                        </p>
                      </div>
                    </td>
                    <td
                      className={`${classes.singleCell}
                ${match.x ? classes.nobt : ''} 
                ${match.y ? classes.nobb : ''}`}
                    >
                      <div className={classes.singleExtremes}>
                        <p
                          id="U"
                          onClick={(e) => {
                            handleOdd(match.p, e);
                          }}
                          className={` 
                      ${
                        // match.tv && match.tv.includes('saba166.com')? classes.hidden :
                        match.old &&
                        match.old.o2 &&
                        match.o2[3] &&
                        match.o2[3] !== match.old.o2[3]
                          ? classes.highlight
                          : ''
                      }
                      ${classes.clickAble}
                      ${match.o2[3] < 0 ? classes.red : ''}
                      `}
                        >
                          {match.o2[3]}
                        </p>
                      </div>
                    </td>
                    <td
                      className={`${classes.singleCell} 
              ${match.x ? classes.nobt : ''} 
              ${match.y ? classes.nobb : ''}`}
                    >
                      <div className={`${classes.singleExtremes}`}>
                        {match && match.o1 && match.o1[5] ? (
                          <p
                            className={` 
                    ${
                      // match.tv && match.tv.includes('saba166.com')? classes.hidden :
                      match.old &&
                      match.old.o1 &&
                      match.o1[5] &&
                      match.o1[5] !== match.old.o1[5]
                        ? classes.highlight
                        : ''
                    }
                    ${classes.handicap}
                    ${match.o1[5] < 0 ? classes.red : ''}
                    `}
                          >
                            {match.o1[5]}
                          </p>
                        ) : (
                          <p
                            className={` 
                    ${
                      // match.tv && match.tv.includes('saba166.com')? classes.hidden :
                      match.old &&
                      match.old.o2 &&
                      match.o2[5] &&
                      match.o2[5] !== match.old.o2[5]
                        ? classes.highlight
                        : ''
                    }
                    ${classes.handicap}
                    ${match.o2[5] < 0 ? classes.red : ''}
                    `}
                          >
                            {match.o2[5]}
                          </p>
                        )}
                      </div>
                    </td>
                    <td
                      className={`${classes.singleCell} 
              ${match.x ? classes.nobt : ''} 
              ${match.y ? classes.nobb : ''}`}
                    >
                      <div className={classes.singleExtremes}>
                        <p
                          id="HTH"
                          onClick={(e) => {
                            handleOdd(match.p, e);
                          }}
                          className={` 
                      ${
                        // match.tv && match.tv.includes('saba166.com')? classes.hidden :
                        match.old &&
                        match.old.o1 &&
                        match.o1[6] &&
                        match.o1[6] !== match.old.o1[6]
                          ? classes.highlight
                          : ''
                      }
                      ${classes.clickAble}
                      ${match.o1[6] < 0 ? classes.red : ''}
                      `}
                        >
                          {match.o1[6]}
                        </p>
                      </div>
                    </td>
                    <td
                      className={`${classes.singleCell}
              ${match.x ? classes.nobt : ''} 
              ${match.y ? classes.nobb : ''}`}
                    >
                      <div className={classes.singleExtremes}>
                        <p
                          id="HTA"
                          className={` 
                      ${
                        // match.tv && match.tv.includes('saba166.com')? classes.hidden :
                        match.old &&
                        match.old.o2 &&
                        match.o2[6] &&
                        match.o2[6] !== match.old.o2[6]
                          ? classes.highlight
                          : ''
                      }
                      ${classes.clickAble}
                      ${match.o2[6] < 0 ? classes.red : ''}
                      `}
                          onClick={(e) => {
                            handleOdd(match.p, e);
                          }}
                        >
                          {match.o2[6]}
                        </p>
                      </div>
                    </td>
                    <td
                      className={`${classes.singleCell}
              ${match.x ? classes.nobt : ''} 
              ${match.y ? classes.nobb : ''}`}
                    >
                      <div className={`${classes.singleExtremes}`}>
                        <p
                          className={` 
                    ${
                      // match.tv && match.tv.includes('saba166.com')? classes.hidden :
                      match.old &&
                      match.old.o1 &&
                      match.o1[7] &&
                      match.o1[7] !== match.old.o1[7]
                        ? classes.highlight
                        : ''
                    }
                    ${classes.handicap}
                    ${match.o1[7] < 0 ? classes.red : ''}
                    `}
                        >
                          {match.o1[7]}
                        </p>
                      </div>
                    </td>
                    <td
                      className={`${classes.singleCell}
              ${match.x ? classes.nobt : ''} 
              ${match.y ? classes.nobb : ''}`}
                    >
                      <div className={classes.singleExtremes}>
                        <p
                          id="HTO"
                          onClick={(e) => {
                            handleOdd(match.p, e);
                          }}
                          className={` 
                    ${
                      // match.tv && match.tv.includes('saba166.com')? classes.hidden :
                      match.old &&
                      match.old.o1 &&
                      match.o1[8] &&
                      match.o1[8] !== match.old.o1[8]
                        ? classes.highlight
                        : ''
                    }
                    ${classes.clickAble}
                    ${match.o1[8] < 0 ? classes.red : ''}
                    `}
                        >
                          {match.o1[8]}
                        </p>
                      </div>
                    </td>
                    <td
                      className={`${classes.singleCell}
              ${match.x ? classes.nobt : ''} 
              ${match.y ? classes.nobb : ''}`}
                    >
                      <div className={classes.singleExtremes}>
                        <p
                          id="HTU"
                          onClick={(e) => {
                            handleOdd(match.p, e);
                          }}
                          className={` 
                      ${
                        // match.tv && match.tv.includes('saba166.com')? classes.hidden :
                        match.old &&
                        match.old.o2 &&
                        match.o2[8] &&
                        match.o2[8] !== match.old.o2[8]
                          ? classes.highlight
                          : ''
                      }
                      ${classes.clickAble}
                      ${match.o2[8] < 0 ? classes.red : ''}
                      `}
                        >
                          {match.o2[8]}
                        </p>
                      </div>
                    </td>
                    <td
                      className={`${classes.singleCell}
              ${match.x ? classes.nobt : ''} 
              ${match.y ? classes.nobb : ''}`}
                    >
                      {match.tm === undefined ? null : (
                        <>
                          {User ? (
                            <p className={classes.more}>
                              {match.l !== 'Total Corners' &&
                              match.mf &&
                              match.mf.length > 1 &&
                              match.mf[1] ? (
                                <svg
                                  onClick={() => {
                                    match.mf[1] = 0;
                                    setUpdateComponent(new Date());
                                    favMatch(match.mf[0], 0);
                                  }}
                                  className={classes.pointer}
                                  width="16"
                                  height="16"
                                  viewBox="0 0 12 12"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M6 0.144043L7.4165 4.50304H12L8.2915 7.19754L9.708 11.5565L6 8.86254L2.2915 11.5565L3.708 7.19754L0 4.50304H4.5835L6 0.144043Z"
                                    fill="#FAB81D"
                                  />
                                </svg>
                              ) : match.l !== 'Total Corners' ? (
                                <svg
                                  onClick={() => {
                                    match.mf[1] = 1;
                                    setUpdateComponent(new Date());
                                    favMatch(match.mf[0], 1);
                                  }}
                                  className={classes.pointer}
                                  width="16"
                                  height="16"
                                  viewBox="0 0 12 12"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M6 2.58658L7.1675 4.99508L9.82 5.36108L7.8895 7.21608L8.3605 9.85108L6 8.58908L3.6395 9.85158L4.1105 7.21658L2.18 5.36158L4.8325 4.99508L6 2.58658ZM6 0.293579L4.166 4.07758L0 4.65308L3.032 7.56708L2.292 11.7066L6 9.72308L9.708 11.7061L8.968 7.56658L12 4.65308L7.834 4.07808L6 0.293579Z"
                                    fill="#FAB81D"
                                  />
                                </svg>
                              ) : (
                                ''
                              )}
                            </p>
                          ) : (
                            ''
                          )}
                        </>
                      )}
                    </td>
                  </tr>
                </React.Fragment>
              ))}
          </tbody>
        </table>
      )}
    </>
  );
};

export default lifecycle(methods)(TableInfo);
